/** @file Set of mesh edge keys (min * 65536 + max) in an open-addressing table the caller owns. */
import { edgeTableSlots } from './edgeTableSlots';

/** The set drawWire dedupes triangle edges with (one mesh at a time); keys are integers in [0, 2^32), -1 = empty. */
export const edgeKeys = {
  /** Empties the first edgeTableSlots(n) slots of `table` for up to `n` keys; returns the probe mask. */
  reset(table: Float64Array, n: number): number {
    const size = edgeTableSlots(n);
    table.fill(-1, 0, size);
    return size - 1;
  },
  /** Adds `key`; true when it was not in the set before (linear probing from a multiplicative hash). */
  add(table: Float64Array, mask: number, key: number): boolean {
    for (let h = (Math.imul(key >>> 0, 0x9e3779b1) >>> 0) & mask; ; h = (h + 1) & mask) {
      const k = table[h] ?? -1;
      if (k === key) return false;
      if (k === -1) {
        table[h] = key;
        return true;
      }
    }
  },
};
